import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Slider from "react-slick";

import shape from '../../images/project/shapebg-3.svg'
import lineGreen from '../../images/service/liine-green.svg'

// Use a visible placeholder image
import placeholderImg from '../../images/about/about-bg.jpg';

const EventSectionS2 = (props) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const res = await fetch('/api/events');
                const data = await res.json();
                setEvents(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching events:', error);
                setEvents([]);
            } finally {
                setLoading(false);
            }
        };
        fetchEvents();
    }, []);

    const getEventImage = (event) => {
        if (event.image_url) return event.image_url;
        // Use placeholder image
        return placeholderImg;
    };

    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
            }
        },

        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            }
        }
        ]
    };


    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-12">
                        <div className="section-title text-center">
                            <span style={{color: '#FFFFFF'}}>Community Gatherings</span>
                            <h2>Our <span style={{position: 'relative', color: '#2A896F'}}>Events
                                <img src={lineGreen} alt="" style={{position: 'absolute', left: 0, bottom: '-10px', width: '100%'}} />
                            </span> & Programmes</h2>
                        </div>
                    </div>
                </div>
            </div>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#fff' }}>Loading events...</div>
            ) : (
                <Slider {...settings} className="project-slider-s2">
                    {events.slice(0, 6).map((event, eitem) => (
                        <div className="project-card" key={event.id || eitem}>
                            <img src={getEventImage(event)} alt={event.title} />
                            <div className="content">
                                <h2><Link onClick={ClickHandler} to={`/event-single/${event.slug}`}>{event.title}</Link></h2>
                                <span>{event.event_date || event.subtitle}</span>
                                <div className="icon">
                                    <Link onClick={ClickHandler} to={`/event-single/${event.slug}`}>
                                        <i className="flaticon-arrow-up"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            )}
            <div className="bg-shape">
                <img src={shape} alt="" />
            </div>
        </section>
    );
};

export default EventSectionS2;
